import React, { useEffect, useMemo } from 'react'
import NotificationNavItem from '@/pages/notification/layout/NotificationNavItem.tsx'
import { useSearchParams } from 'react-router-dom'
import { isEmpty } from '@/util/strings.ts'
import { useTranslation } from 'react-i18next'

interface IProps {
    className?: string;
    children?: any
}

const NotificationLayout: React.FunctionComponent<IProps> = ({ className, children }) => {
    const { t } = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()

    const navItems = useMemo(() => {
        return [
            { id: 'sos_alert',           label: t('notification.layout.tab.sos'),           href: '/notification?tab=sos',           tab: 'sos' },
            { id: 'bio_alert',           label: t('notification.layout.tab.bio'),           href: '/notification?tab=bio',           tab: 'bio' },
            { id: 'falldetection_alert', label: t('notification.layout.tab.falldetection'), href: '/notification?tab=falldetection', tab: 'falldetection' }
        ]
    }, [t])

    useEffect(() => {
        if (isEmpty(searchParams.get('tab') || '')) {
            setSearchParams({ tab: 'sos' })
        }
    }, [])

    return (
        <div>
            {/* 탭 버튼 스타일 변경 */}
            <div className="flex px-5 mt-5 gap-3 border-b border-gray-400">
                {navItems.map(item => (
                    <NotificationNavItem {...item} key={item.id} />
                ))}
            </div>

            {/* 콘텐츠 */}
            <div className={className}>
                {children}
            </div>
        </div>
    )
}

export default NotificationLayout
